// extracted by mini-css-extract-plugin
module.exports = {"IconButton":"IconButton_IconButton__B_e-p","BorderedIconButton":"IconButton_BorderedIconButton__3Gjix","PaddedIcon":"IconButton_PaddedIcon__3ClID","Icon":"IconButton_Icon__tvJeH"};